import React from 'react'
import { Content } from '../../components/Content'

export function BillingList(): React.ReactElement {
	return <Content variant="wide">BillingList</Content>
}
